import { Link, useParams } from "react-router-dom";
import { ArrowLeft, CheckCircle2, Hammer } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PageHeader, Panel, StatusBadge } from "@/components/common/ui-kit";

export default function PlaceholderModule({ module }) {
  const { recordId } = useParams();
  const Icon = module.icon;
  return (
    <div data-testid={`module-page-${module.id}`}>
      <PageHeader overline={`Modulo · Fase ${module.phase}`} title={module.label} description={module.description} />
      <Panel className="p-6 sm:p-8 animate-rise delay-1">
        <div className="flex flex-col gap-6 sm:flex-row sm:items-start">
          <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-card bg-brand-50 text-brand-600"><Icon className="h-6 w-6" strokeWidth={1.75} /></div>
          <div className="flex-1">
            <StatusBadge tone="blue" data-testid="module-phase-badge">Disponibile nella Fase {module.phase}</StatusBadge>
            {recordId && (
              <p className="mt-4 rounded-lg bg-slate-50 px-3 py-2 text-sm text-slate-600" data-testid="module-record-reference">
                Hai aperto un collegamento a un record. La scheda di dettaglio sarà disponibile con questo modulo.
              </p>
            )}
            <h3 className="mt-5 flex items-center gap-2 text-sm font-semibold text-slate-800"><Hammer className="h-4 w-4 text-slate-400" />Cosa conterrà</h3>
            <ul className="mt-3 grid gap-2 sm:grid-cols-2">
              {module.features.map((f) => (
                <li key={f} className="flex items-center gap-2 text-sm text-slate-600"><CheckCircle2 className="h-4 w-4 text-slate-300" />{f}</li>
              ))}
            </ul>
            <p className="mt-6 text-xs text-slate-400">Struttura dati, permessi e ricerca globale sono già predisposti per questo modulo.</p>
            <Button asChild variant="outline" className="mt-6 gap-2" data-testid="module-back-dashboard-button">
              <Link to="/dashboard"><ArrowLeft className="h-4 w-4" />Torna alla Dashboard</Link>
            </Button>
          </div>
        </div>
      </Panel>
    </div>
  );
}
